import { Fragment } from "react";
import "../../../assets/styles/footer/mobilefooter.scss";
import FBIcon from "../../../assets/icons/facebook.png";
import InstaIcon from "../../../assets/icons/instagram.png";
import YoutubeIcon from "../../../assets/icons/linekdin.png";
import PinrestIcon from "../../../assets/icons/Pinterestlogo.png";

import visaIcon from "../../../assets/icons/visa-card.png";
import masterIcon from "../../../assets/icons/master-card.png";
import codIcon from "../../../assets/icons/cash1.png";
import mailIcon from "../../../assets/icons/mail.png";
import phoneIcon from "../../../assets/icons/phone-call.png";
import sogplaystoreicon from "../../../assets/images/playstore.svg";
import sogappstoreicon from "../../../assets/images/appstore.svg";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const WebsiteFooter = (props) => {
  const { t } = useTranslation();
  const BECOME_SELLER_LINK = process.env.REACT_APP_VENDOR_DOMAIN;

  return (
    <Fragment>
      <div className="mobilewebsitefooter2025">
        <div className="website-footer  mx-auto px-0">
          <div className="coloured-bottom-footer">
            <div className="row follow-us-row mx-auto d-flex helpfooter">
              <div className="copy-right-col">
                {props.language === "ar" ? (
                  <div className="help text-align-right">تحتاج مساعدة؟</div>
                ) : (
                  <div className="help">Need Help?</div>
                )}
              </div>

              <div className="channel d-flex helpcolright">
                <div className="help-contact">
                  <img
                    src={phoneIcon}
                    className="pointer"
                    style={{ height: "12px", width: "12px" }}
                    alt=""
                  />
                  <span className="helptex">+971 54 306 4845</span>
                </div>
                <div className="help-contact">
                  <img
                    src={mailIcon}
                    className="pointer"
                    style={{ height: "12px", width: "12px" }}
                    alt=""
                  />
                  <span className="helptex">sales@alisouq.com</span>
                </div>
                <div className="help-contact">
                  <img
                    src={mailIcon}
                    className="pointer"
                    style={{ height: "12px", width: "12px" }}
                    alt=""
                  />
                  <span className="helptex">customerservice@alisouq.com</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bottom-footer">
            <div className="about-and-contact-row">
              <div className="d-flex justify-content-end footer-menu-col">
                <div className="header-row d-flex flex-column">
                  <div
                    className={
                      props.language === "ar"
                        ? "header mb-2 text-right"
                        : "header mb-2 text-left"
                    }
                  >
                    {t("dekstop-footer.who-we-are.who-we-are")}
                  </div>
                  <div className="font-family-fm">
                    <Link
                      to={
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/alisuq-story"
                      }
                    >
                      {t("dekstop-footer.who-we-are.story")}
                    </Link>
                    <a href={`${BECOME_SELLER_LINK}`}>
                      {t("dekstop-footer.customer-service.sell-with-us")}
                    </a>

                    <Link
                      to={
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/bulk-order"
                      }
                    >
                      {t("dekstop-footer.quick-links.bulk-enq")}
                    </Link>
                    <Link
                      to={
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/brand-favourites"
                      }
                    >
                      {t("dekstop-footer.who-we-are.brandfav")}
                    </Link>

                    <Link
                      to={
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/brands-az"
                      }
                    >
                      {t("dekstop-footer.who-we-are.brands")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end footer-menu-col">
                <div className="header-row px-lg-0 d-flex flex-column">
                  <div
                    className={
                      props.language === "ar"
                        ? "header mb-2 text-right"
                        : "header mb-2 text-left"
                    }
                  >
                    {t("dekstop-footer.customer-service.customer-service")}
                  </div>
                  <div className="font-family-fm pointer">
                    <Link to="/login">
                      {t("dekstop-footer.quick-links.sign-in")}
                    </Link>
                    <Link
                      to={
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/contact-us"
                      }
                    >
                      {t("dekstop-footer.customer-service.contact-us")}
                    </Link>

                    <Link
                      to={
                        "/" +
                        props.countryUrl +
                        "-" +
                        props.language +
                        "/shipping-policy"
                      }
                    >
                      {t("dekstop-footer.customer-service.ship-deliver")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-end footer-menu-col">
                <div className="header-row px-lg-0 d-flex flex-column">
                  <div
                    className={
                      props.language === "ar"
                        ? "header mb-2 text-right"
                        : "header mb-2 text-left"
                    }
                  >
                    {t("dekstop-footer.legal.legal")}
                  </div>

                  <Link
                    to={
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/terms-and-conditions"
                    }
                  >
                    {t("dekstop-footer.customer-service.toc")}
                  </Link>
                  <Link
                    to={
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/return-refunds"
                    }
                  >
                    {t("dekstop-footer.customer-service.ret-ref")}
                  </Link>
                  <Link
                    to={
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/privacy-policy"
                    }
                  >
                    {t("dekstop-footer.customer-service.privacy-policy")}
                  </Link>
                  <Link
                    to={
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/consumer-rights"
                    }
                  >
                    {t("dekstop-footer.who-we-are.c-rights")}
                  </Link>
                  <Link
                    to={
                      "/" +
                      props.countryUrl +
                      "-" +
                      props.language +
                      "/payment-options"
                    }
                  >
                    {t("dekstop-footer.customer-service.payments")}
                  </Link>
                </div>
              </div>
            </div>
            <div className="shopongo" style={{ paddingRight: "15px" }}>
              <div className="shopongocol" style={{ marginLeft: "100px" }}>
                <div className="sog-heading">Get The ALISOUQ APP </div>
                <div className="sog-icon-row">
                  <a href="https://play.google.com/store/apps/details?id=com.alisuq">
                    <img
                      src={sogplaystoreicon}
                      className="sog-icon"
                      alt="PLaystore"
                    />
                  </a>
                  <a href="https://apps.apple.com/gb/app/alisuq/id1608295886">
                    <img
                      src={sogappstoreicon}
                      className="sog-icon"
                      alt="App Store"
                    />
                  </a>
                </div>
              </div>
              <div className="shopongocol" style={{ display: "contents" }}>
                <div className="channel d-flex justify-content-center align-items-center flex-nowrap">
                  <a
                    href="https://www.facebook.com/alisouqworld"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={FBIcon}
                      className="pointer"
                      style={{ height: "15px", width: "15px" }}
                      alt=""
                    />
                  </a>

                  <a
                    href="https://www.instagram.com/alisouq.com_/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={InstaIcon}
                      className="pointer"
                      style={{ height: "15px", width: "15px" }}
                      alt=""
                    />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/alisouq/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={YoutubeIcon}
                      className="pointer"
                      style={{ height: "15px", width: "15px" }}
                      alt=""
                    />
                  </a>
                  <a
                    href=" https://www.pinterest.com/alisouquae/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={PinrestIcon}
                      className="pointer"
                      style={{ height: "15px", width: "15px" }}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.language.language,
    countryUrl: state.language.countryUrl,
  };
};
export default connect(mapStateToProps, null)(WebsiteFooter);
